<app-auth-layout>
  <div class="cont">
    <img class="logo" src="./assets/images/logo.svg" />

    <h1>{{lockMessage}}</h1>
    
    <p><a href="#">Contact Sync customer service</a> for further assistance.</p>

    <sync-button
      label="Back to sign in"
      [leadAdornment]="true"
      leadIconAdornment="arrow-left"
      [onClick]="onClickBackToSignIn"
    />
  </div>
</app-auth-layout>